import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-terms-offcanvas',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './terms-offcanvas.component.html',
  styleUrl: './terms-offcanvas.component.scss'
})
export class TermsOffcanvasComponent {
  @Input() language: 'en' | 'es' = 'en';
  /** When true, renders only the body content (no offcanvas wrapper) for use inside a modal */
  @Input() inModal: boolean = false;
}
